import { L as ListItem, d as defineCustomElement$1 } from './p-96ee8029.js';
const OwcListItem = ListItem;
const defineCustomElement = defineCustomElement$1;
export { OwcListItem, defineCustomElement };